import { useEffect } from 'react'
import { getAddOns } from '../services'
import { useAddonsStore } from '../store'

export const useGetAddons = () => {
  const isLoading = useAddonsStore((state) => state.isLoading)
  const setIsLoading = useAddonsStore((state) => state.setIsLoading)
  const addons = useAddonsStore((state) => state.addons)
  const setAddons = useAddonsStore((state) => state.setAddons)
  const isError = useAddonsStore((state) => state.isError)
  const setIsError = useAddonsStore((state) => state.setIsError)

  const fetchAddons = async () => {
    setIsLoading(true)
    try {
      const response = await getAddOns()
      if (response.isSuccess && response.data) {
        setAddons(response?.data)
        setIsError(false)
      } else {
        setIsError(true)
      }
    } catch {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!addons && !isError && !isLoading) {
      fetchAddons()
    }
  }, [addons])

  return {
    fetchAddons,
    isLoading,
    addons,
    isError
  }
}
